import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, MessageCircle, ArrowUp } from "lucide-react";

const FloatingActions = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          className="fixed bottom-6 right-6 z-40 flex flex-col gap-3"
          data-testid="floating-actions"
        >
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            data-testid="float-scroll-top"
            className="h-12 w-12 bg-white text-[#101D2C] border border-slate-200 flex items-center justify-center shadow-lg hover:bg-[#58BCFA] hover:border-[#58BCFA] transition-all duration-300"
            aria-label="Retour en haut"
          >
            <ArrowUp className="h-5 w-5" />
          </button>

          <a
            href="tel:+14505781383"
            data-testid="float-phone"
            className="h-12 w-12 bg-[#101D2C] text-[#58BCFA] flex items-center justify-center shadow-lg hover:bg-[#58BCFA] hover:text-[#101D2C] transition-all duration-300"
            aria-label="Appeler"
          >
            <Phone className="h-5 w-5" />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingActions;
